module.exports = __webpack_public_path__ + "img/logo_white.79991ffc.svg";